import { useEffect, useState } from "react"
import debounceMatchMedia from "shared/lib/debounce_match_media"
import { ProgressBar } from "./progress_bar"
import classnames from "classnames"

import iftttLogo from "images/logo-ifttt.svg"
import chevronLeftBlack from "images/layout/chevron-left-black.svg"
import "./header.scss"

const minModalWidth = 850
interface Props {
  onClickBack: () => void
  onSkip?: (page: string) => void
  title: string | object
  page?: string
  progressBarSteps?: Array<string>
  hideBackButton?: boolean
}

const Header = ({ onClickBack, title, onSkip, page, progressBarSteps, hideBackButton }: Props) => {
  const renderSkip = (page === "services" || page === "applets") && onSkip
  const [isDesktop, setDesktop] = useState(window.matchMedia(`(min-width: ${minModalWidth}px)`)?.matches)

  useEffect(debounceMatchMedia.bind(null, minModalWidth, setDesktop), [])

  return (
    <header styleName={classnames("onboarding-header", { trial: page === "trial" })}>
      <div>
        {hideBackButton ? (
          <a title="Home" styleName="logo" aria-label="The IFTTT home page" href="/my_applets">
            <span className="svg-icon" dangerouslySetInnerHTML={{ __html: iftttLogo }} />
          </a>
        ) : (
          <button
            type="submit"
            styleName="back"
            className="button-tertiary button-outlined button-with-icon only-icon-on-mobile"
            aria-label="Back button"
            onClick={() => {
              onClickBack()
            }}
          >
            <span
              className="button-icon"
              dangerouslySetInnerHTML={{
                __html: chevronLeftBlack,
              }}
            />
            <span className="hide-on-xs">Back</span>
          </button>
        )}
        {isDesktop && progressBarSteps && <ProgressBar progressBarSteps={progressBarSteps} page={page as string} />}
        {renderSkip && page === "services" && (
          <a
            styleName="skip"
            aria-label="Skip button"
            onClick={() => {
              onSkip(page)
            }}
          >
            Skip
          </a>
        )}
        {renderSkip && page === "applets" && (
          <button
            aria-label="Continue button"
            styleName="continue"
            className="button-tertiary"
            onClick={() => {
              onSkip(page)
            }}
          >
            Continue
          </button>
        )}
      </div>
      <h1>{title}</h1>
    </header>
  )
}

export default Header
